import { render, staticRenderFns } from "./addGf.vue?vue&type=template&id=50ef6503&scoped=true"
import script from "./addGf.vue?vue&type=script&lang=js"
export * from "./addGf.vue?vue&type=script&lang=js"
import style0 from "./addGf.vue?vue&type=style&index=0&id=50ef6503&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ef6503",
  null
  
)

export default component.exports